import React from 'react';
import { Typography } from '@dagensmat/carrot/Components';
import i18n from 'i18n';
import Button, {
  ButtonContainer
} from '_common/components/button/Button.style';
import { postResetPassword } from 'api';
import FormField from '_common/components/input/FormField';
import { Page } from '@components/page';

const statuses = {
  error: {
    code: 'error',
    message: i18n.t('common:SomethingWentWrongContactSupport')
  },
  success: {
    code: 'success',
    message: i18n.t('common:WeSentYouAnEmailWithInstructions')
  }
} as const;

const ResetPasswordPage = () => {
  const [email, setEmail] = React.useState('');
  const [status, setStatus] =
    React.useState<(typeof statuses)[keyof typeof statuses]>();

  const onSubmitHandler: React.FormEventHandler<HTMLFormElement> = async e => {
    e.preventDefault();

    try {
      await postResetPassword({ email });
      setStatus(statuses.success);
    } catch {
      setStatus(statuses.error);
    }
  };

  return (
    <Page>
      <form onSubmit={onSubmitHandler}>
        <FormField
          required
          labelText={i18n.t('signup:emailLabelText')}
          type="email"
          placeholder={i18n.t('common:WriteEmailToReset')}
          onChange={({ target: { value } }) => {
            setEmail(value);
          }}
          name="loginEmail"
          value={email}
        />
        {status && status.code === statuses.error.code && (
          <Typography variant="paragraph" color="error">
            {status.message}
          </Typography>
        )}
        {status && status.code === statuses.success.code && (
          <Typography variant="paragraph" color="black">
            {status.message}
          </Typography>
        )}
        {!status && (
          <ButtonContainer>
            <Button type="submit" variant="secondary">
              {i18n.t('common:ResetWithArrow')}
            </Button>
          </ButtonContainer>
        )}
      </form>
    </Page>
  );
};

export default ResetPasswordPage;
